var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 -489.811L-489.811 256L-116.905 628.906L628.906 -116.906L256 -489.811Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M628.906 -116.905L-116.905 628.906L256 1001.81L1001.81 256.001L628.906 -116.905Z",
    fill: "#3498DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M584.838 -181.168L-181.167 584.838L-72.8379 693.167L693.168 -72.8381L584.838 -181.168Z",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.556 -127.37L-127.37 569.557L-57.5566 639.37L639.37 -57.5564L569.556 -127.37Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-164.01 655.958L598.4 -141.631L685.142 -92.7989L639.488 -88.1482L-127.488 695.489L-164.01 655.958Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/TZ.9d8d0d64c4e8a1ed0c3fee0ca9ddcab9.svg";
export { ForwardRef as ReactComponent };